/**
 * I provide FaceBook integration
 *
 * @file    facebook.service.js
 *
 */

SP.Helpers.registerModule( 'facebook.service', function( moduleName, _ ) {
    'use strict';

    /**
     * I am a jQuery.onload callback, triggered from the module manager
     *
     * @param {Function} $ jQuery object
     */
    function actOnLoad( $ ) {
        var
            $fbStatus = $( '.fb-status' );

        // Exit early if Facebook functionality is disabled
        if ( !(SP && SP.API && SP.API.facebook && SP.API.facebook.appID) ) {
            window.console.warn( '#Facebook login disabled' );
            return;
        }

        // Load Facebook script asynchronously
        $.ajax(
            {
                url: '//connect.facebook.net/en_UK/all.js',
                dataType: "script",
                cache: true
            } )
            // Script loaded
            .done( function() {
                window.console.info( '#Facebook: script loaded' );
                FB.init( {
                    appId: SP.API.facebook.appID,
                    // enable cookies to allow the server to access
                    cookie: true,
                    // parse social plugins on this page
                    xfbml: true,
                    // use version 2.0
                    version: 'v2.0'
                } );

            } )
            // Loading failed
            .fail( function() {
                window.console.error( '#Facebook: script loading failed' );
            } )
        ;

    }

    return {
        name: moduleName,
        onLoad: actOnLoad
    };
} );
